import React, { createContext, useState, useEffect } from "react";

// Routes
import Bakgrunn from "pages/Bakgrunn";
import Inspirasjon from "pages/Inspirasjon";
import Galleri from "pages/Galleri";
import Broderier from "pages/Broderier";

export const DataContext = createContext();
export const DataProvider = ({ children }) => {
    const data = {
        seo: {
            home: {
                title: "Nålens Makt",
                description:
                    "Prosjektet Nålens makt startet i januar 2019 med en serie av broderings workshops over 6 uker. Workshopene brakte sammen kvinner med flyktning- og migrasjonsbakgrunn og kvinner fra lokalsamfunnet. Kvinnene fikk i oppgave å brodere i fellesskap et eget motiv som skulle uttrykke noe om sin identitet og kulturarv. Broderingsinstallasjonen er satt sammen av alle disse individuelle broderiene. «Nålens makt» handler om å styrke kvinners egen bevissthet, gjeninnføre brodering som uttrykksform og vise betydningen det kan ha.",
                image: process.env.PUBLIC_URL + "images/meta-image.jpg",
            },
            bakgrunn: {
                title: "Nålens Makt - bakgrunn",
                description: "",
                image: "",
            },
            inspirasjon: {
                title: "Nålens Makt - inspirasjon",
                description: "",
                image: "",
            },
            galleri: {
                title: "Nålens Makt - galleri",
                description: "",
                image: "",
            },
            broderier: {
                title: {
                    en: "Nålens Makt - broderier",
                    no: "Power of The Needle - embroideries",
                },
                description: "",
                image: "",
            },
        },
        title: {
            no: "Nålens makt",
            en: "Power of The Needle",
        },
        nextButton: {
            no: "Neste",
            en: "Next",
        },
        pages: {
            bakgrunn: {
                cssModifier: "bakgrunn",
                label: { no: "Bakgrunn", en: "Background" },
                to: { no: "/bakgrunn", en: "/background" },
                component: Bakgrunn,
                content: {
                    title: {
                        no: "Bakgrunn",
                        en: "Background",
                    },
                    subtitle: {
                        no: "Dagens kvinner broderer fortellinger om identitet, motstand og kulturarv",
                        en: "Women of today are embroidering stories about identity, resistance and cultural heritage",
                    },
                },
            },
            inspirasjon: {
                cssModifier: "inspirasjon",
                label: { no: "Inspirasjon", en: "Inspiration" },
                to: { no: "/inspirasjon", en: "/inspiration" },
                component: Inspirasjon,
                content: {
                    title: {
                        no: "Inspirasjon",
                        en: "Inspiration",
                    },
                },
                lommetorkle: {
                    title: {
                        no: "Kroken, Grini 1944-45",
                        en: "Kroken, Grini 1944-45",
                    },
                    description: {
                        no: "<p>På dette broderiet har 24 norske Grini-fanger brodert sine signaturer. Dette er kvinner som av ulike årsaker satt i tysk fangenskap under andre verdenskrig. Broderiet «Kroken, Grini 1944-45» dokumenterer kvinnenes felles skjebne og er i ettertid blitt et symbol på kampånd og samhold. Kristiansandskvinnen Mary Hansen satt på Grini høsten 1942 før hun ble sendt videre til leiren Ravensbrück. Mary forteller om det sterke samholdet som oppsto mellom kvinnene da de møttes over fellesaktiviteter som håndarbeid, broderi eller opplesninger. </p>",
                        en: "<p>In this embroidery 24 Norwegian Grini-prisoners have embroidered their signatures. These are women that for different reasons were kept in German captivity during the Second World War. The embroidery “Kroken, Grini 1944-45” documents the common fate of these women and has today become a symbol of fighting spirit and unity. The woman Mary Hansen from Kristiansand was at Grini in the Autumn of 1942, before she was sent to the Ravensbrück camp. Mary is telling about the strong unity that occurred between the women when they met up for joint activities like handicraft, embroidery or readings. </p>",
                    },
                },
                duk: {
                    title: {
                        no: "Duk",
                        en: "Tablecloth",
                    },
                    description: {
                        no: '<p>Lærer Caroline Moe fra Fjære broderte på denne duken fra 1940 til 1945. I Grimstadområdet var det kjent at Moe skulle arbeide med duken så lenge krigen varte. Duken skal ha vært i bruk kun en gang: da nyheten om Hitlers død nådde Grimstad.</p><p>Om symbolikken: Borden med motsatte kors skal symbolisere falne på begge sider under krigen. Her fins referanser til Maginotlinjen og slagene ved Pantelaria, Lampedusa og Midway. Langs kanten rundt er verselinjer brodert inn.</p><p>Påskrift : Mod mørke makter sting for sting er stukket I tunge tider tvilen aldri slukket En trøstig tro på dagen til den bruk Som eslet er til denne duk (Mer info <a href="https://digitaltmuseum.no/021026606810/duk">https://digitaltmuseum.no/021026606810/duk</a>)</p>',
                        en: '<p>Lærer Caroline Moe fra Fjære broderte på denne duken fra 1940 til 1945. I Grimstadområdet var det kjent at Moe skulle arbeide med duken så lenge krigen varte. Duken skal ha vært i bruk kun en gang: da nyheten om Hitlers død nådde Grimstad.</p><p>Om symbolikken: Borden med motsatte kors skal symbolisere falne på begge sider under krigen. Her fins referanser til Maginotlinjen og slagene ved Pantelaria, Lampedusa og Midway. Langs kanten rundt er verselinjer brodert inn.</p><p>Påskrift : Mod mørke makter sting for sting er stukket I tunge tider tvilen aldri slukket En trøstig tro på dagen til den bruk Som eslet er til denne duk (Mer info <a href="https://digitaltmuseum.no/021026606810/duk">https://digitaltmuseum.no/021026606810/duk</a>)</p>',
                    },
                },
                signaturer: {
                    title: {
                        no: "Deltakere",
                        en: "Participants ",
                    },
                    description: {
                        no: "<p>Prosjektet Nålens makt viderefører noen av de samme verdiene fra «Kroken, Grini 1944-45» når kvinner med ulik bakgrunn, nasjonalitet, alder og religion møtes over et felles arbeid. Broderiene i utstillingen handler om hver kvinnes identitet, men forteller også om ønsket om et fellesskap og verdien av å lære av hverandre. Dette broderiet viser navnene på alle deltakerne i «Nålens makt».</p>",
                        en: "<p>The Power of the Needle project continues with some of the same values from “Kroken, Grini 1944-45”, when women from different backgrounds, nationalities, age and religion meet over joint activity. The embroideries in this exhibition presents every woman’s identity, their desire for a shared unity and the value of learning from each other. This embroidery contains the names of all the participants in “The Power of the Needle”.      </p>",
                    },
                },
            },
            galleri: {
                cssModifier: "galleri",
                label: { no: "Galleri", en: "Gallery" },
                to: { no: "/galleri", en: "/gallery" },
                component: Galleri,
                workshops: [
                    {
                        date: {
                            no: "1 mars",
                            en: "1 march",
                        },
                    },
                    {
                        date: {
                            no: "5 februar",
                            en: "5 february",
                        },
                    },
                    {
                        date: {
                            no: "12 februar",
                            en: "12 february",
                        },
                    },
                    {
                        date: {
                            no: "29 januar",
                            en: "29 january",
                        },
                    },
                ],
            },
            broderier: {
                cssModifier: "broderier",
                label: { no: "Broderier", en: "Embroideries" },
                to: { no: "/broderier", en: "/embroideries" },
                component: Broderier,
            },
        },
        // pages: [
        //     { label: "Bakgrunn", to: "/bakgrunn" },
        //     { label: "Inspirasjon", to: "/inspirasjon" },
        //     { label: "Galleri", to: "/galleri" },
        //     { label: "Broderier", to: "/broderier" },
        // ],
        broderier: [
            {
                author: "Mette Skofteby",
                description: {
                    no: "Jeg har sydd landskapet som jeg kommer fra, fjell som betyr mye for meg. Jeg er glad i naturen. På bildet er sauer, snille og hyggelige dyr som vi hadde hjemme da jeg var barn og som bidrar til å vedlikeholde kulturlandskapet. Jeg er glad i håndarbeid og særlig alt som har med ull  å gjøre. Jeg er barnslig, så jeg har laget broderiet naivt og barnslig. Jeg har også prøvd å legge inn kjærlighet og omsorg for andre, som disse sauene utstråler.",
                    en: "I have embroidered the mountainous landscape where I come from because it means a lot to me. I love nature. The embroidery depicts the sheep we had at my childhood home. Sheep are nice and gentle animals that contribute to maintaining the culture landscape. I love handicrafts, especially everything to do with wool. I’m pretty childish, thus my motif is naïve and childlike. I’ve also tried to add love and caring for others, which the sheep are an expression of. ",
                },
            },

            {
                author: "Carola Andersen",
                description: {
                    no: "Jeg har valgte en blomst som har mange farger. For meg betyr det glede, håp og kjærlighet.",
                    en: "I’ve chosen a flower with lots of colours. To me this means happiness, hope and love. ",
                },
            },

            {
                author: "Birgitte Kleivset",
                title: { no: "Å bli en stemme", en: "To Be a Voice" },
                description: {
                    no: "<p>Camilla Collett ble født i Kristiansand, i Dronningensgade i 1813. I 1854 ble hun Norges første samfunnskritiske forfatter og feminist da hun gav ut romanen Amtmandens Døtre. Camilla mistet ektemannen og bestevennen da hun var 40 år, satte bort to av fire barn og befant seg på reisefot i europeiske storbyer livet ut. Hun levde av det hun skrev, og fortalte om ensomheten i å være en «stemme fra de stummes leir.»</p>",
                    en: "<p>Camilla Collett was born in Dronningensgate in Kristiansand, Norway in 1813. With her novel “The Amtmanden’s Daughters” that was published in 1854 she became the first feminist and socially critical author in Norway. Camilla lost her husband and her best friend when she was 40 years old. She placed her children away while she travelled around European cities for the rest of her life. Her writing earned her a living, and she wrote about the loneliness in being “a voice for the voiceless”. </p>",
                },
            },

            {
                author: "Sophie Spickenbom",
                title: { en: "Hello world!", no: "Hello world!" },
                description: {
                    no: "<p>Det er så mange mennesker å treffe og smil og dele. Det er så mange øyeblikk å nyte og eventyr å oppleve. Det er hyggelig å treffe deg!</p>",
                    en: "<p>There are so many people to meet and so many smile to share. There are so many moments to enjoy and adventures to experience. Hello, it’s nice to meet you!</p>",
                },
            },

            {
                author: "Lizbet Henriksen",
                title: {
                    no: "Kolibri i Vinterland",
                    en: "“A Hummingbird in the Winterland”",
                },
                description: {
                    no: "<p>Jeg er norsk men har vokst opp i Karibien og bor nå i Norge.</p>",
                    en: "<p>I am Norwegian but have grown up in the Caribbean. I now live in Norway.</p>",
                },
            },

            {
                author: "Heidi Aune Solaas",
                description: {
                    no: "<p>Utsikt, overblikk, innsikt. <br/>Hvile blikket, hvile sjelen. <br/>Hente kraft i fjell, hav, strand, minner.</p>",
                    en: "<p>View, overview, insight. <br/>Rest your gaze, rest your soul. <br/>Gather strength from the mountains, the sea, and memories. </p>",
                },
            },

            {
                author: "Gro Kvanvig",
                title: {
                    no: "Mellom Himmel og jord”",
                    en: "“In between Sky and Earth”",
                },
                description: {
                    no: "<p>Strøblomster preget av de fire elementer.</p>",
                    en: "<p>Shrub flowers embossed by the four elements. </p>",
                },
            },

            {
                author: "Khetam Hussein",
                description: {
                    no: "<p>Klippedomen (arabisk: Qubbat As-Sakhrah), ofte omtalt som Klippemoskeen, er en muslimsk helligdom. Klippedomen regnes som verdens eldste islamske byggverk, og ble bygget i 687–691 av Abd al-Malik, i det niende kalifatet. Den står oppført på Tempelhøyden i Jerusalem. Palestinaskjerf ( الكوفية الفلسطينيه) Er et skjerf består av sort og hvit farge laget av bomullsstoff. Palestinaskjerfet ble et palestinsk kjennetegn siden invasjon datert i 1936.</p>",
                    en: "<p>The Dome of the Rock (in Arabic: Qubbat As-Sakhrah) is an Islamic temple. The rock dome is considered the world’s oldest Islamic construction. It was built in 687 – 692 CE by Abd al-Malik in the ninth kalifate. It’s placed on the Temple Mount in Jerusalem. The Palestinian scarf consists of the colours black and white and it’s made out of cotton. The Palestinian scarf became a symbol for Palestinians since the invasion in 1936. </p>",
                },
            },

            {
                author: "Signe Klepp",
                description: {
                    no: "<p>Jeg elsker havet, være i det, under det, på det.   Kajakken gir denne fantastiske nærkontakten med havet – nå tror jeg at jeg kommer til å utvide med nattpadling!</p>",
                    en: "<p>I love being in, under and on the sea. The kayak creates an explicitly close connection to the sea – now I think I’m going to expand and start night-paddling!</p>",
                },
            },

            {
                author: "Susanne Hoff",
                description: {
                    no: "<p>Jeg har med alderen forstått at jeg ikke kan fortsette å elske andre uten å elske meg selv også – det vil bare slite meg ut. Dersom jeg lærer å elske meg selv, vil min kjærlighet for andre vokse som et tre. </p>",
                    en: "<p>With age I have now understood that I cannot love others before I can love myself – it will only tire you out. If I learn to love myself, my love for others will grow like a tree. </p>",
                },
            },

            {
                author: "Katrina Flett Gulbrandsen",
                title: { no: "Vandreren", en: "The Wanderer" },
                description: {
                    no: "<p>Blomster jeg har samlet fra steder jeg har bodd og elsket. Disse stedene er nå en del av meg, men ettersom jeg vandrer rundt om i verden og utforsker nye plasser, må jeg alltid reise fra et sted som er et hjem.</p>",
                    en: "<p>The flowers are collected from places I have lived and loved. These places are now a part of me, but as I am still wandering around the world and exploring new places, I must always leave a place that is home. </p>",
                },
            },

            {
                author: "Nurizat Sadyrbaeva",
                description: {
                    no: "<p>I midten har jeg brodert noen typiske mønstre fra Kirgisistan, der jeg kommer ifra. Fargene der representerer Sverige og Norge, der jeg har bodd og bor nå. Jeg tror at man blir påvirket av de som er rundt. Blomstene og bladene har friske farger, og de representerer åpenhet for nye ting og mennesker. </p>",
                    en: "<p>In the middle I have embroidered typical patterns from where I am from, Kyrgyzstan. The colours represent Sweden where I’ve lived and Norway where I live now. I believe we get effected by the people around us. The flowers and the leaves have fresh colours, and they represent openness for new things and people. </p>",
                },
            },

            {
                author: "Phuong Minh Huynh",
                title: {
                    no: "Å sitte godt mellom to stoler",
                    en: "Sitting Comfortable Between Two Chairs",
                },
                description: {
                    no: "<p>- ordspill med god selvfølelse. Strøblomster med farger fra det vietnamesiske flagget.</p>",
                    en: "<p>A confident play with words. Shrub flowers with colours from the flag of Vietnam. </p>",
                },
            },

            {
                author: "Helen Nygård",
                description: {
                    no: "<p>Et tre med røtter jeg er stedbundet. Telt og bål er speider. Sjø og skjær fra min oppvekst. En Skarv en majestestisk fugl. Liker å reise og oppdage nye plasser.</p>",
                    en: "<p>A tree with roots from where I’m place-bound. The tent and the bonfire represent scouting. The sea and the berg comes from where I grew up. The majestic bird cormorant. I like to travel and experience new places. </p>",
                },
            },

            {
                author: "Lilian Mwangi",
                title: { no: "Håp i sorg", en: "Hope in Grief" },
                description: {
                    no: "<p>Trestammene symboliserer mine tre brødre som har blitt drept. Rosen symboliserer en venn som tok sitt liv. Bølgen symboliserer livet som skyller over meg og hvor vanskelig det er å holde hode over vannet. Flammen er håpet i det vanskelige.</p>",
                    en: "<p>The tree trunk symbolizes my three brothers that have been killed. The rose symbolizes a friend that took suicide. The wave symbolizes life that flushes over me and makes it hard to keep my head above water. The flame is hope within the difficult.</p>",
                },
            },

            {
                author: "Stine S. Laursen",
                description: {
                    no: "<p>Viktigheten av å bli forstått, ha en stemme og bli anerkjent. Gjennom prosjektet har jeg gjennoppdaget min kreative side og fått en helt annen forståelse for arbeidet min farmor la ned  ved å brodere 8 bunader. Jeg har brukt lilla farge som både min farmor og jeg var/er glade i. Lilla farge symboliserer her makt (kvinnemakt, nålens makt), ettertanke og oppgjør. Sommerfuglen symboliserer vekst, frihet og fornyelse.</p>",
                    en: "<p>It’s important to be understood, to have a voice and to be acknowledged. Through this project I’ve rediscovered my creative side and gained a whole new understanding for all the work my grandmother put in embroidering eight bunad’s (Norwegian national dresses). I’ve used the colour purple which both my grandmother and myself are found of. The colours purple symbolizes power (women’s power, the power of the needle), reflection and settlement. The butterfly symbolizes growth, freedom and renewal. </p>",
                },
            },

            {
                author: "Iris Dahle Bjørkmann",
                title: { no: "Circle of Life", en: "Circle of Life" },
                description: {
                    no: "<p>Parallelt med vår egen livslinje og identitet har vi også en felles identitet som er vår essensielle natur. Et møtested der vi kan speile hverandre i følelsen av det å være et menneske på tross av landegrenser, kultur, arv, miljø og vår historie.</p>",
                    en: "<p>There’s a common identity which is essential to our nature, parallel to this is our own timeline and identity. A meeting place where we can mirror each other within the feeling of being human, despite boarders, culture, heritage, environment, and our history. </p>",
                },
            },

            {
                author: "Birgitte Kleivset",
                title: { no: "GRO DEG ET PAR", en: "Grow a Pair" },
                description: {
                    no: "It is a human right that girls, boys, women and men have the same rights and choices. This must be incorporated into the language as well and how we describe certain strengths and solidarity. ",
                    en: "It is a human right that girls, boys, women and men have the same rights and choices. This must be incorporated into the language as well and how we describe certain strengths and solidarity. ",
                },
            },

            {
                author: "Kathrine Gregersen",
                description: {
                    no: "<p>Har brukt restene etter broderigarnet frå Rogalandsbunaden som mor mi sydde til meg til konfirmasjonen. Eg planla ingenting på førehand, men fann stor glede med å bygge på Mandalaen min lag for lag.</p>",
                    en: "<p>I have used the left over embroidery yarn from the Rogalandsbunad (Norwegian national dress) that my mum sewed to me for my confirmation. I didn’t plan anything beforehand, but I found great joy in building the mandala layer by layer.</p>",
                },
            },

            {
                author: "Unn Sigmundsdatter Skibekk",
                description: {
                    no: "<p>Broderiet er i korssting i et symmetrisk motiv. Det opprinnelige motivet er fra Palestina og symboliserer et sypresstre. Det minner meg om sypresslunder jeg har sett mange steder på mine reiser, og gir meg gode minner.</p>",
                    en: "<p>The embroidery is done with cross stiches in a symmetrical motif. The original motif is from Palestine and symbolizes a cypress tree. It reminds me of the cypress groves I have seen many places on my travels which are good memories for me.</p>",
                },
            },

            {
                author: "Unn Sigmundsdatter Skibekk",
                description: {
                    no: "<p>Jeg har brodert symboler fra livet mitt, og begynte med et stort hjerte som symboliserer kjærlighet, til barn, til kjæreste, familie, venner og livet. Så broderte jeg litt bunadbroderi som viser til mitt yrke, og til tradisjon og historie. Jeg har fylt på med blomster som vokser vilt, og jeg er glad i frodighet, farger og myke former. Som en ramme har jeg solen med sitt lys og sin varme, og mellom solstrålene er små motiver som viser hendelser og interesser fra livet mitt. Og så har jeg festet på et linstykke hvor jeg har skrevet et lite livsmotto: OPP IGJEN!</p>",
                    en: "<p>I have embroidered symbols from my life. I started with a big heart that symbolizes the love for; children; partner; family; friends and life itself. Then I embroidered some “bunadsbroderi” (traditional embroidery for the Norwegian national suit) which relate to my occupation, traditions and history. I have filled in wildflowers, and I like lushness, colours and soft forms. The frame is the sun with its light and warmth. In between the ray of sunlight shows small motifs of events and interests from my life. In addition, I’ve attached a piece of linen where I’ve written a life motto: “UP AGAIN!”</p>",
                },
            },

            {
                author: "Solveig Hessaa-Szwinto",
                title: { no: "Frihet", en: "Freedom" },
                description: {
                    no: "Kvinnen symboliserer min indre identitet som er fast og som ikke endrer seg etter hvor jeg bor eller hvilken kultur jeg tilhører. Kirsebærblomst treet er vakkert og gir meg en følelse av frihet og starten på noe nytt.",
                    en: "<p>The woman symbolizes my inner identity which is permanent and does not change despite where I live, or which culture I belong to. The cherry blossom tree is beautiful. It gives me a feeling of freedom and the start of something new.</p>",
                },
            },

            {
                author: "Nazira Manan",
                description: {
                    no: "<p>Afghansk mønster i svart og hvit</p>",
                    en: "<p>Afghan pattern in black and white. </p>",
                },
            },

            {
                author: "Sakhida Beg",
                description: {
                    no: "<p>Jeg broderer ordtaket: «Hjemme er der hvor hjertet er». Jeg synes at der hvor man føler seg trygg, er hjemme vårt.</p>",
                    en: "<p>I have embroidered the saying: “Home is where the heart is”. I think home is where you feel safe.</p>",
                },
            },

            {
                author: "Hiyam Ahmed",
                title: {
                    no: "Yousef og Sommerfuglen",
                    en: "Yousef and the Butterfly",
                },
                description: {
                    no: "<p>Jeg elsker sommerfugler. Min yngste sønn minner meg om en sommerfugl. </p>",
                    en: "<p>I love butterflies. My youngest son reminds me of a butterfly. </p>",
                },
            },

            {
                author: "Nazira Manan",
                description: {
                    no: "<p>Motivet kommer fra en duk jeg broderte da jeg var 14 år. I vårt land (Afganistan) var vi veldig opptatt med å sy da vi var unge, for å lære å sy og andre ting slik at vi kan vise til noe når vi skal gifte oss. Jerg er veldig glad i å sy og har sydd mye som voksen også.</p>",
                    en: "<p>The motif comes from a tablecloth which I embroidered when I was 14 years old. In our country (Afghanistan) we sewed and embroidered a lot. We got taught how to sew and embroider (amongst other things) in order to gain skills we could show for when we got married. I love embroidering and have done it a lot in my adult life as well. </p>",
                },
            },

            {
                author: "Andrea Wold Johansen",
                title: {
                    no: "Hjemme former hjertet",
                    en: "Home Shapes the Heart",
                },
                description: {
                    no: "<p>Et spill på å føle at man har flere hjem, og at alle disse hjemmene er med på å forme ens identitet. Motivet er av en bølge. Den representerer alle stedene jeg har bodd og følt meg trygg; de har alle vært ved havet. Bølgen er rammet inn av Winchester Cathedrals blyglassvindu, et sted som for meg representerer mestring, stolthet og følelsen av å stå på egne ben. Bak bølgen og vinduet står tredjeverset i Erik Byes «Vår Beste Dag», et vers med en helt egen følelse av håp, takknemlighet og det å være spent for det nye og ukjente. Nede i hjørnet lurer det en liten lavendel-kvast; et bilde på familien min og barndomshjemmet med lavendelbusker i hagen. Ingenting lukter så «hjemme» som lavendel. </p>",
                    en: "<p>You have several homes and all of these homes play a part in shaping your identity. The motif is a wave. The wave represents all the places I have lived and felt safe; they have all been by the ocean. The wave is framed by the led-glasswindow in Winchesters Cathedrals, a place that to me represents mastery, pride and independence. Behind the wave and the window stands the third verse in Erik Bye’s “The Best Day” (“Vår Beste Dag”). A verse with a unique feeling of hope, gratitude, and the excited feeling for the new and unknown. Down in the corner there’s a little lavender twig luring; an illustration of my family and my childhood home with lavender bushes in the garden. Nothing else but lavender smells like home. </p>",
                },
            },

            {
                author: "Grethe Geitle",
                title: { no: "Samisk kultur", en: "Sàpmi Culture" },
                description: {
                    no: "<p>Den er fantastisk viktig fordi de lever i pakt med naturen og tar vare på den på en bedre måte enn nordmenn gjør. Ett eksempel: De har 500 ord for snø. Disse nyansene har fanget forskeres interesse, det kan gi ny kunnskap om mijøet. De må kjempe, og kjemper fortsatt en kamp for at kulturen deres skal overleve!</p>",
                    en: "<p>The Sàpmi culture is tremendously important because they live in harmony with nature and takes care of it in a better way then what Norwegians do. One example: They have 500 words for snow. These nuances have caught the scientist attention, they can give more knowledge about the environment. They have to fight, and they are still fighting for their culture to survive! </p>",
                },
            },

            {
                author: "Esperanza Skjefstad",
                title: {
                    no: "Om røttene er dype, er det ingen grunn til å frykte vinden",
                    en: "Deep Roots Cannot Fear the Wind",
                },
                description: {
                    no: "<p>Jeg forsøker å vokse røtter, og verdsetter trygghet. Jeg stikker hånden i elven, og forsøker å erfare øyeblikket. Jeg elsker å leve, og våger å drømme. Det vonde og vanskelige er en del av livet for alle, men generasjon etter generasjon har vandret veien før oss. I den vissheten ligger det trygghet, styrke, noen ganger trøst. Falle -- og reise seg igjen. </p>",
                    en: "<p>I am trying to grow roots and I value safety. I put my hand in the river and try to experience the moment. I love living and I dear to dream. The painful and the difficult are part of life for everyone. Generation after generation have wandered the same roads before us. In this wisdom lies safety, strength and sometimes comfort. Fall – and lift yourself up again. </p>",
                },
            },

            {
                author: "Marlena Mielczarek",
                description: {
                    no: "<p>Jeg bestemte meg for å dedikere mitt arbeid til sønnen min. Victor ble født med en kritisk medfødt hjertesykdom. Den høyre delen av hjertet hadde en liten feil som er skildret med forskjellige rød farger. Den grønne fargen står for håp. Vi håpet på helbredelse men det skjedde ikke. Etter to kirurgiske prosedyrer da Victor var helt nyfødt bestemte legene seg for å utføre en åpen hjerteoperasjon. Victor overlevde. Han var en av de yngste pasientene som tok en slik operasjon. Gulfargen er hjerteslag som et symbol på seier og ubeskrivelig lettelse og glede. </p>",
                    en: "<p>I decided to dedicate my embroidery to my son. Victor was born with a critical heart condition. The right side of his heart had a small defect, which is depicted with all the different red colours. The green colour stands for hope. We hoped for it to heal but it didn’t. When Victor was a newborn, after two surgical interventions, the doctors decided to perform an open-heart surgery. Victor survived. He was one of the youngest patients that had gone through such an operation. The yellow colour is the heartbeat which symbolizes victory and the indescribable feeling of relief and joy. </p>",
                },
            },

            {
                author: "Birgitte Kleivset",
                title: { no: "JAVEL", en: "Alright" },
                description: {
                    no: "<p>På Sørlandet sier mange dette istedet for a si HEI eller HALLO. Javel, er det neste man ville si etter at man har sagt hei & hallo. Dette viser egentlig at folk i sør er uformelle og vennlige.</p>",
                    en: "<p>In the south of Norway many people say this instead of “hi” or “hello”.  You typically say “alright” after you’ve said hi or hello. This actually shows that people in the south are informal and friendly. </p>",
                },
            },

            {
                author: "Hyunju Kang",
                description: {
                    no: "<p>Jeg har brodert en vårhage for det har vært så kalt og mørkt denne vinteren. Jeg elsker våren. De ulike blomstene er fra Norge og Sør-Korea. Jeg er spesielt glad i kirsebærblomst trærne fra Korea. </p>",
                    en: "<p>I have embroidered a spring garden because this winter has been so dark and cold. I love spring. The different flowers are from Norway and South-Korea. I especially like the cherry blossom trees from Korea. </p>",
                },
            },

            {
                author: "Israa Issa Mahameed",
                description: {
                    no: "<p>Broderiet er inspirert av et tradisjonell palestinsk mønster som heter Bethlehem. Farger jeg har brukt er tradisjonelle farger som har spesifikk betydning i palestinsk kultur, rød er kjærlighet og liv, blå er himmel og have og gul er sol og varme.</p>",
                    en: "<p>The embroidery is inspired by a traditional Palestinian pattern called Bethlehem. I have used traditional colours that have particular meaning in Palestinian culture. Red is love and life, blue is sky and ocean, yellow is sun and warmth.</p>",
                },
            },

            {
                author: "Saskia Klooster",
                description: {
                    no: "<p>Jeg ble født i området i Nederland, mellom Haarlem og Haag i vesten av landet, hvor de dyrker blomster (mest tulipaner, roser og hyasinter). Min oldefar drivet enn av største gårder i området hvor jeg vokste opp. Hvert år i slutten av april endrer dette området i en kjempe flott utsikt av farger så langt du kan se, på grunn av blomster som kommer opp. Jeg tror jeg skal for resten av levet mitt huske og elske dette imponerende bildet, som er stort sett gravert i minnet mitt.</p>",
                    en: "<p>I was born in the west of the Netherlands, in an area between Haarlem and the Haag which they grow flowers (mostly tulips, roses and hyacinths). My great grandfather farmed one of the biggest farms in this area. Every year in the end of April when the flowers flowered, the area changed into a magnificent view of colours as long as the eye could see. I will always remember and cherish this memory, it is engraved in my mind forever. </p>",
                },
            },

            {
                author: "Maria Widzisz",
                description: {
                    no: "<p>Dette broderiet har jeg brodert etter en tegning av min datter. Min datter er tyve år, og veldig flink til å tegne. Denne tegningen er noen år gammel, men jeg har tatt vare på den. Jeg har brodert på den tradisjonelle norske måten, med ull på ull.</p> ",
                    en: "<p>I have embroidered this embroidery after one of my daughter’s drawings. My daughter is 20 years old and a very talented drawer. This drawing is a couple of years old, but I have kept it. I have embroidered in the traditional Norwegian style, wool on wool.</p>",
                },
            },

            {
                author: "Signe Røynås",
                title: { no: "Livets tre", en: "The Tree of Life" },
                description: {
                    no: "<p>For at treet skal bære frukter, må det ha jordforbindelse. Vi må gi barna en trygg og sikker start i livet for at de skal blomstre.</p>",
                    en: "<p>The tree needs connection to the ground or earth for it to bear fruits. For children to flourish, we have to give them a safe and secure start in life. </p>",
                },
            },
        ],
    };

    /* ********************************** */
    /*            MEDIA QUERIES           */
    /* ********************************** */
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const updateSize = () => {
        setScreenWidth(window.innerWidth);
    };
    useEffect(() => {
        window.addEventListener("resize", updateSize);
    }, []);
    const [isTouch, setIsTouch] = useState(false);
    useEffect(() => {
        if (window.matchMedia("(pointer: coarse)").matches) {
            // touchscreen
            setIsTouch(true);
        } else {
            setIsTouch(false);
        }
    }, []);
    const [language, setLanguage] = useState("no");
    return (
        <DataContext.Provider
            value={{
                screenWidth,
                data,
                isTouch,
                language,
                setLanguage,
            }}
        >
            {children}
        </DataContext.Provider>
    );
};
